import { Component } from '@angular/core';
import { I18NService } from '../../../shared/i18n/i18n.service';
import { IPlaceValuelistService } from '../../../iPlace/iPlace-valuelist.service';
import { TankService } from '../Tank.service';
import { TankBook } from '../tank-books/tank-book';
import { TankBooksService } from '../tank-books/tank-books.service';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { AuthService } from '../../../shared/auth/auth.service';
import { TagService } from '../../tag/Tag.service';
import { Globals } from '../../../globals';
import { ItemTagType } from '../../tag/Tag';
import { Tank } from '../Tank';

@Component({
  selector: 'app-levels-graph',
  templateUrl: './levels-graph.component.html',
  styleUrls: ['./levels-graph.component.css']
})
export class LevelsGraphComponent {

  isLoading = false;
  bsConfig: Partial<BsDatepickerConfig>;
  bsValue: any;
  dropdownList: any = [];
  dropdownListTanks: any = [];
  selectedItems: any;
  selectedTanks: any = [];
  items: any[] = [];
  itemTags: any[] = [];
  iPlaceList: any[] = [];
  iPlaceMap: any[];
  tanks: any[] = [];
  tankBook: TankBook[] = [];
  dropdownSettings:any = {};
  dropdownTanksSettings: any = {};
  selected: boolean = false;
  dateRangeFilter:any;
  currentTank: Tank;

  constructor(private i18nService: I18NService,
              private iPlaceValuelistService: IPlaceValuelistService,
              private tankService: TankService,
              private tankBooksService: TankBooksService,
              private authService: AuthService,
              private tagService: TagService,
              private globals: Globals) {

    this.bsConfig = Object.assign({}, {containerClass: "theme-custom", showWeekNumbers: false});
    let startDate = new Date();
    startDate.setHours(0,0,0,0);
    let endDate = new Date();
    endDate.setHours(0,0,0,0);
    endDate = new Date(endDate.getTime() - 86400000);
    this.dateRangeFilter = [endDate, startDate];

    if ( (<any> Object).values(this.iPlaceValuelistService.getValuelist()).length ) {
      this.iPlaceList = (<any>  Object).values(this.iPlaceValuelistService.getValuelist())
        .sort((a: any, b: any) => a.iPlaceName.localeCompare(b.iPlaceName));
      this.iPlaceMap = this.iPlaceList.reduce((previous: any, current: any) => {
        previous[current.id] = current;
        return previous;
      }, {});
      this.getStoreLevelsGraph();
    } else {
      this.iPlaceValuelistService.reload()
        .then( () => {
          this.iPlaceList = (<any> Object).values(this.iPlaceValuelistService.getValuelist())
            .sort((a:any, b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
          this.iPlaceMap = this.iPlaceList.reduce((previous: any, current: any) => {
            previous[current.id] = current;
            return previous;
          }, {});
          if ( globals.tenant == "ecomanager" ) {
            this.setGroupedIPlaceList();
          } else {
            this.dropdownList = this.iPlaceList;
          }
          this.getStoreLevelsGraph();
        });
    }

    let groupBy = null;

    if ( globals.tenant == "ecomanager" ) {
      groupBy = "tag";
      this.tagService.getItemTags(ItemTagType.IPLACE)
        .then( itemTags => {
          this.itemTags = itemTags;
          this.setGroupedIPlaceList();
        });
    } else {
      this.dropdownList = this.iPlaceList;
    }

    this.isLoading = false;

    this.dropdownSettings = {
      singleSelection: true,
      enableCheckAll: false,
      enableFilterSelectAll: false,
      primaryKey: 'idiPlace',
      labelKey: 'iPlaceName',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: i18nService.get("selectStation"),
      searchPlaceholderText: i18nService.get("search"),
      badgeShowLimit: 2,
      enableSearchFilter: true,
      groupBy: groupBy,
      classes: "form-angular2-multiselect"
    };

    this.dropdownTanksSettings = {
      singleSelection: true,
      enableCheckAll: false,
      primaryKey: 'tankId',
      labelKey: 'name',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: i18nService.get("selectTank"),
      searchPlaceholderText: i18nService.get("search"),
      enableSearchFilter: true,
      classes: "form-angular2-multiselect tank-select"
    };
  }

  onItemSelect(item: any) {
    this.reloadTanks();
  }

  onItemDeSelect(item: any) {
    this.clearFilters();
  }

  onTankSelect(item: any) {
    this.reloadItems();
  }

  onTankDeselect(item: any) {
    this.tanks = [];
  }

  onDateRangeChange(any: any) {
    this.bsValue = any;
    if(this.selectedTanks.length > 0) {
      this.reloadItems();
    }
  }

  clearFilters() {
    this.selectedItems = null;
    this.items = [];
    this.tanks = [];
    this.selectedTanks = [];
    this.dropdownListTanks = [];
    this.selected = false;
    this.setStoreLevelsGraph();
  }

  private getStoreLevelsGraph()  {
    let data = localStorage.getItem("levels_graph_"+ this.authService.getUserID());;
    if( data ) {
      if( JSON.parse(data)[0] && JSON.parse(data)[0].length > 0 ) {
        this.items = JSON.parse(data)[0]
          .filter(item => this.iPlaceList.findIndex(iPlace => iPlace.idiPlace == item.idiPlace) != -1);
        this.selectedItems = this.items.map(item => this.iPlaceMap[item.id]);
        this.getTanksByiPlace();
      }
      if( JSON.parse(data)[1] && JSON.parse(data)[1] != null ) {
        this.selectedTanks.push(JSON.parse(data)[1] as any[]);
        this.tanks = this.tanks.filter(item => this.selectedTanks.findIndex(selected => selected.tankId == item.tankId) != -1);
        let newItems = this.selectedTanks.filter(selected => this.tanks.findIndex(item => selected.tankId == item.tankId) == -1);
        this.tanks.push(...newItems);
        this.getTankSeries();
      }
    }
  }

  private setStoreLevelsGraph() {
    localStorage.setItem("levels_graph_" + this.authService.getUserID(), JSON.stringify([this.items, this.selectedTanks[0]]));
  }

  reloadTanks() {
    this.items = this.items.filter(item => this.selectedItems.findIndex(selected => selected.idiPlace == item.idiPlace) != -1);
    let newItems = this.selectedItems.filter(selected => this.items.findIndex(item => selected.idiPlace == item.idiPlace) == -1);
    this.items.push(...newItems);

    this.getTanksByiPlace();
  }

  private reloadItems() {
    this.tanks = this.tanks.filter(item => this.selectedTanks.findIndex(selected => selected.tankId == item.tankId) != -1);
    let newItems = this.selectedTanks.filter(selected => this.tanks.findIndex(item => selected.tankId == item.tankId) == -1);
    this.tanks.push(...newItems);

    this.getTankSeries();
  }

  private getTanksByiPlace() {
    let iPlaceIds = this.selectedItems[0].idiPlace;
    this.selectedTanks = [];
    this.dropdownListTanks = [];
    this.selected = false;

    if(iPlaceIds != null) {
      this.tankService.getTanks(iPlaceIds).then(response => {
        this.tanks = response
          .sort((a, b) => a.localTankId < b.localTankId ? -1 : a.localTankId > b.localTankId ? 1 : 0)
          .filter(tank => tank.productId != null);

        this.tanks.forEach(tank => {
          tank.name = this.i18nService.get("tank") + " " + tank.localTankId + " - " + this.i18nService.get(tank.productId);
        });
        this.dropdownListTanks = this.tanks;
      });
    } else {
      this.dropdownListTanks = [];
    }
  }

  private getTankSeries() {
    this.isLoading = true;

    if(this.tanks.length > 0) {
      this.currentTank = this.tanks[0];
      let startDate = this.dateRangeFilter[0].getTime();
      let endDate = this.dateRangeFilter[1].getTime();
      this.tankBooksService.getSeries(this.tanks[0].tankId, startDate, endDate).then(response => {
        this.isLoading = false;
        this.tankBook = response;
        this.setStoreLevelsGraph();
        this.selected = true;
      }).catch(error => {
        this.isLoading = false;
      });
    } else {
      this.setStoreLevelsGraph();
      this.isLoading = false;
    }
  }

  private setGroupedIPlaceList() {
    if ( this.iPlaceMap ) {
      this.itemTags.forEach(itemTag => {
        let iplace = this.iPlaceMap[itemTag.id.itemId];
        if ( iplace && !iplace.tag ) {
          iplace.tag = itemTag.id.tagKey;
        }
      });
    }

    if ( this.iPlaceList.length ) {
      if ( !this.itemTags || !this.itemTags.length ) {
        this.dropdownSettings.groupBy = false;
      }
    }

    this.dropdownList = this.iPlaceList.sort((a:any, b:any) => {
      if ( !a.tag ) {
        return -1
      } else if (a.tag == b.tag) {
        return a.iPlaceName.localeCompare(b.iPlaceName);
      } else {
        return a.tag.localeCompare(b.tag);
      }
    });
  }
}
